import apolloClient from "../apolloClient";
import {
	GET_PRODUCTS,
	GET_PRODUCTS_BY_COLLECTION,
	GET_VARIANT,
} from "./graphql";

class ProductService {
	async all() {
		const response = await apolloClient.query({
			query: GET_PRODUCTS,
		});
		return response.data.products.nodes;
	}

	async fetchByCollection(collectionId) {
		const response = await apolloClient.query({
			query: GET_PRODUCTS_BY_COLLECTION,
			variables: {
				collectionId,
			},
		});
		return response.data.productCollection.nodes;
	}

	async getVariant(id) {
		const response = await apolloClient.query({
			query: GET_VARIANT,
			variables: {
				id,
			},
		});
		return response.data.variant;
	}
}

export default new ProductService();
